import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';

interface BaseCustomShadowColorPanelProps {
  dropShadowColor: RGBA;
  onUpdateColor(updatedColor: RGBA, undoable?: boolean): void;
}

export function BaseCustomShadowColorPanel({...props}: BaseCustomShadowColorPanelProps): ReactElement<any> {
  const updateCustomShadow = (dropShadowColor: RGBA, undoable = true): void => {
    props.onUpdateColor(dropShadowColor, undoable);
  };

  const onChangeCustomShadowColor = (updatedColor: ColorStorage[]): void => {
    updateCustomShadow(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateCustomShadow(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };

  return (
    <PosterEditingBaseColorPanel
      id="custom-shadow-color-panel"
      color={getColorObjectArrayFromFillColor([props.dropShadowColor])}
      onChangeColor={onChangeCustomShadowColor}
      onChangeEnded={onChangeColorEnded}
      isGradientEnabled={false}
    />
  );
}
